<section class="px-4">
  <!-- Loader -->
  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

  <!-- Error -->
  <div *ngIf="!loading && errorMsg" class="error">
    <mat-icon>error_outline</mat-icon>
    {{ errorMsg }}
    <button translate mat-stroked-button (click)="getPagesByWebsiteId()">
      Retry
    </button>
  </div>

  <!-- Content -->
  <ng-container *ngIf="!loading && !errorMsg">
    <div class="d-flex justify-content-between align-items-center">
      <div class="page_header">
        <button class="back_icon me-2" (click)="goBack()">
          <i class="fa-solid fa-arrow-left"></i>
        </button>
        <h3 translate class="m-0 page_header_title">Page List</h3>
      </div>
      <div *ngIf="actiondata?.create">
        <button
          translate
          mat-raised-button
          color="primary"
          (click)="openAddPageDialog()"
          class="px-5 add_button"
        >
          Add
        </button>
      </div>
    </div>

    <div class="page-name-list-container card_container mt-3">
      <div *ngIf="noData" class="no-data-message">
        <p translate>
          No pages available. Please add a page to manage your content.
        </p>
        <button
          class="btn add_button center mat-elevation-z4"
          mat-button
          (click)="openAddPageDialog()"
        >
          <i class="fa-solid fa-plus"></i>
          <span>Add Page</span>
        </button>
      </div>

      <div *ngIf="pages && pages.length > 0" class="page-cards-container">
        <mat-card
          *ngFor="let page of pages"
          class="page-card card_container_upper"
        >
          <!-- (click)="viewPageComponents(page.id) -->
          <div class="card-header">
            <div class="title-section">
              <h3 class="website-title">{{ page.name }}</h3>
            </div>
            <!-- <button
              mat-icon-button
              [matMenuTriggerFor]="pageMenu"
              aria-label="Page actions menu"
              (click)="$event.stopPropagation()"
            >
            <i class="fa-solid fa-ellipsis-vertical"></i>
            </button> -->
            <div
              class="action_button cursor_pointer"
              [matMenuTriggerFor]="pageMenu"
              aria-label="Page actions menu"
              (click)="$event.stopPropagation()"
            >
              <i class="text_color fa-solid fa-ellipsis-vertical"></i>
            </div>

            <mat-menu #pageMenu="matMenu">
              <p
                class="m-0"
                mat-menu-item
                (click)="viewPageComponents(page.id)"
              >
                <span translate>View Page Components</span>
              </p>
              <p
                class="m-0"
                mat-menu-item
                (click)="openEditPageNameDialog(page)"
              >
                <span translate>Edit Page</span>
              </p>
              <p class="m-0" mat-menu-item (click)="deletePage(page.id)">
                <span translate>Delete Page</span>
              </p>
            </mat-menu>
          </div>

          <mat-card-content>
            <p>{{ page.description }}</p>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </ng-container>
</section>
